<template>
  <div class="home home_i" ref="scrollContainer">
    <div class="home-header">
      <headerTop :opacity="opacity" />
      <div class="gub">
        <div class="header-font">
          <p class="header-font-p">智领未来，触手可及，共建智能生态</p>
          <p class="header-font-t">
            大模型广场，AI时代的创新引擎！赋能千行百业！
          </p>
          <p class="header-font-s">让每个创意都有AI翅膀，飞向智能新纪元！</p>
        </div>
        <!-- <div class="home-box">
          <div class="home-box-content">
            <div class="box-list">
              <div class="list-box">
                <svg
                  t="1742963768980"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2758"
                  width="40"
                  height="40"
                >
                  <defs>
                    <linearGradient
                      id="gradientx"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    >
                      <stop
                        offset="0%"
                        style="stop-color: #7aaafd; stop-opacity: 1"
                      />
                      <stop
                        offset="100%"
                        style="stop-color: #3981fe; stop-opacity: 1"
                      />
                    </linearGradient>
                  </defs>
                  <path
                    d="M744.040284 124.508671L535.172275 6.133778a47.081166 47.081166 0 0 0-46.377189 0l-208.953339 118.396226c-7.167772 4.053204-13.119582 9.919684-17.258117 17.002125a46.142529 46.142529 0 0 0-6.314465 23.31659v235.960479a46.163862 46.163862 0 0 1-23.295258 40.254716l-209.614652 120.465494A46.291858 46.291858 0 0 0 0 601.82679v235.981812c0 8.191739 2.175931 16.212817 6.314465 23.31659 4.159867 7.082441 10.111678 12.948921 17.27945 17.002124l208.868009 118.460224c14.420874 8.085076 31.956315 8.085076 46.377188 0l209.891976-118.758881a47.017168 47.017168 0 0 1 46.441187 0l209.891976 118.737549c14.420874 8.106408 32.084311 8.106408 46.377188 0l208.868009-118.438892c7.189104-4.053204 13.140914-9.919684 17.300782-17.002124 4.159867-7.082441 6.357131-15.146184 6.357131-23.31659V601.82679a46.291858 46.291858 0 0 0-23.359255-40.254717l-209.614652-120.529491a46.163862 46.163862 0 0 1-23.380588-40.254717V164.763388a46.163862 46.163862 0 0 0-23.572582-40.318715v0.063998z m-181.967533 158.565613v246.733468l213.923847 122.662757a17.386112 17.386112 0 0 1 8.575727 17.36478 17.279449 17.279449 0 0 1-2.218596 6.421129l-28.500425 49.065102a17.45011 17.45011 0 0 1-17.471443 8.533062 17.556774 17.556774 0 0 1-6.463794-2.175931l-214.222505-122.876083-214.201172 122.812085a17.514108 17.514108 0 0 1-23.95657-6.378463l-28.479092-49.065103a17.300782 17.300782 0 0 1 6.335798-23.764576l214.649158-123.046744V283.010286c0-9.663692 7.786418-17.492776 17.45011-17.492776h57.043516c9.685025 0 17.535441 7.893082 17.535441 17.492776v0.063998z"
                    fill="url(#gradientx)"
                    p-id="2759"
                  ></path>
                </svg>

                <div class="list-box-content">
                  <span
                    style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >111</span
                  >
                  <span style="font-size: 0.85rem">模型托管数量</span>
                </div>
                <div class="list-box-content">
                  <span
                    style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >65</span
                  >
                  <span style="font-size: 0.85rem">模型部署数量</span>
                </div>
              </div>
              <el-divider direction="vertical"></el-divider>
              <div class="list-box">
                <svg
                  t="1742965679316"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2937"
                  width="40"
                  height="40"
                >
                  <defs>
                    <linearGradient
                      id="gradientxl"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    >
                      <stop
                        offset="0%"
                        style="stop-color: #7aaafd; stop-opacity: 1"
                      />
                      <stop
                        offset="100%"
                        style="stop-color: #3981fe; stop-opacity: 1"
                      />
                    </linearGradient>
                  </defs>
                  <path
                    d="M988.821333 353.749333l-148.629333 148.693334a120.085333 120.085333 0 0 1-169.834667 0l-148.650666-148.693334a120.149333 120.149333 0 0 1 0-169.898666l148.650666-148.672a120.106667 120.106667 0 0 1 169.813334 0l148.650666 148.693333a120.149333 120.149333 0 0 1 0 169.877333z m-658.410666 140.202667H120.021333A120.106667 120.106667 0 0 1 0 373.888V163.712a120.170667 120.170667 0 0 1 120.021333-120.32h210.133334a120.170667 120.170667 0 0 1 120.277333 120.064v210.154667a120.170667 120.170667 0 0 1-120.021333 120.32zM860.330667 1024h-210.133334a120.106667 120.106667 0 0 1-120.021333-120.064v-210.154667a120.106667 120.106667 0 0 1 120.042667-120.064h210.112a120.106667 120.106667 0 0 1 120.021333 120.064v210.154667A120.106667 120.106667 0 0 1 860.330667 1024z m-529.92 0H120.021333A120.106667 120.106667 0 0 1 0 903.936v-210.154667a120.170667 120.170667 0 0 1 120.021333-120.32h210.133334a120.106667 120.106667 0 0 1 120.021333 120.042667v210.176a119.893333 119.893333 0 0 1-73.813333 111.146667 119.765333 119.765333 0 0 1-45.952 9.173333z"
                    fill="url(#gradientxl)"
                    p-id="2938"
                  ></path>
                </svg>

                <div class="list-box-content">
                  <span
                    style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >111</span
                  >
                  <span style="font-size: 0.85rem">加速卡数量</span>
                </div>
                <div class="list-box-content">
                  <span
                    style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >65</span
                  >
                  <span style="font-size: 0.85rem">加速卡数量</span>
                </div>
                <div class="list-box-content">
                  <span
                    style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >65</span
                  >
                  <span style="font-size: 0.85rem">占用加速卡</span>
                </div>
              </div>
              <el-divider direction="vertical"></el-divider>
              <div class="list-box">
                <svg
                  t="1742965790260"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3116"
                  width="40"
                  height="40"
                >
                  <defs>
                    <linearGradient
                      id="gradientxa"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    >
                      <stop
                        offset="0%"
                        style="stop-color: #7aaafd; stop-opacity: 1"
                      />
                      <stop
                        offset="100%"
                        style="stop-color: #3981fe; stop-opacity: 1"
                      />
                    </linearGradient>
                  </defs>
                  <path
                    d="M326.4 462.933333h-17.066667v108.8l8.533334 2.133334h8.533333c14.933333 0 25.6-4.266667 34.133333-12.8 8.533333-8.533333 12.8-23.466667 12.8-40.533334 0-19.2-4.266667-32-12.8-42.666666-8.533333-10.666667-19.2-14.933333-34.133333-14.933334z"
                    p-id="3117"
                    fill="url(#gradientxa)"
                  ></path>
                  <path
                    d="M985.6 558.933333c10.666667 0 21.333333-6.4 27.733333-14.933333 6.4-8.533333 10.666667-19.2 8.533334-29.866667 0-10.666667-6.4-21.333333-14.933334-27.733333-8.533333-6.4-19.2-10.666667-29.866666-8.533333h-100.266667v-123.733334h108.8c10.666667 0 21.333333-6.4 27.733333-14.933333 6.4-8.533333 10.666667-19.2 8.533334-29.866667 0-10.666667-6.4-21.333333-14.933334-27.733333-8.533333-6.4-19.2-10.666667-29.866666-8.533333H874.666667c-4.266667-29.866667-19.2-59.733333-40.533334-81.066667s-51.2-38.4-81.066666-42.666667V66.133333c0-10.666667-4.266667-21.333333-12.8-29.866666-8.533333-8.533333-19.2-12.8-29.866667-12.8s-21.333333 4.266667-29.866667 12.8c-8.533333 8.533333-12.8 19.2-12.8 29.866666V149.333333h-123.733333V57.6c-2.133333-12.8-8.533333-23.466667-19.2-32-6.4-4.266667-14.933333-6.4-21.333333-6.4-8.533333 0-14.933333 2.133333-21.333334 6.4-6.4 4.266667-12.8 10.666667-14.933333 17.066667-4.266667 6.4-4.266667 14.933333-4.266667 21.333333v85.333333H341.333333V57.6c0-10.666667-6.4-21.333333-14.933333-27.733333s-17.066667-8.533333-29.866667-8.533334c-10.666667 0-21.333333 6.4-27.733333 14.933334-6.4 8.533333-10.666667 19.2-8.533333 29.866666V149.333333c-32 4.266667-61.866667 21.333333-85.333334 44.8-21.333333 23.466667-36.266667 55.466667-38.4 87.466667H36.266667c-10.666667 2.133333-21.333333 6.4-27.733334 14.933333-4.266667 8.533333-8.533333 19.2-8.533333 29.866667 0 10.666667 6.4 21.333333 14.933333 27.733333 8.533333 6.4 19.2 10.666667 29.866667 10.666667h91.733333v123.733333H36.266667c-10.666667 0-21.333333 6.4-27.733334 14.933334s-8.533333 17.066667-8.533333 27.733333 6.4 21.333333 14.933333 27.733333c8.533333 6.4 19.2 10.666667 29.866667 8.533334h91.733333v123.733333H44.8c-10.666667 0-21.333333 4.266667-29.866667 12.8-8.533333 8.533333-12.8 19.2-12.8 29.866667s4.266667 21.333333 12.8 29.866666c8.533333 8.533333 19.2 12.8 29.866667 12.8h96c6.4 27.733333 21.333333 55.466667 42.666667 74.666667 21.333333 19.2 49.066667 32 76.8 36.266667v91.733333c2.133333 10.666667 6.4 21.333333 14.933333 27.733333 8.533333 6.4 19.2 10.666667 29.866667 8.533334 10.666667 0 21.333333-6.4 27.733333-14.933334 6.4-8.533333 10.666667-19.2 10.666667-29.866666v-81.066667h123.733333v89.6c0 10.666667 6.4 21.333333 14.933333 27.733333 8.533333 6.4 19.2 10.666667 29.866667 8.533334 10.666667 0 21.333333-6.4 27.733333-14.933334s10.666667-19.2 8.533334-29.866666v-81.066667h121.6v81.066667c0 10.666667 4.266667 21.333333 12.8 29.866666 8.533333 8.533333 19.2 12.8 29.866666 12.8 10.666667 0 21.333333-4.266667 29.866667-12.8 8.533333-8.533333 12.8-19.2 12.8-29.866666v-83.2c29.866667-4.266667 59.733333-19.2 81.066667-40.533334 21.333333-21.333333 36.266667-51.2 40.533333-81.066666H981.333333c10.666667 0 19.2-6.4 25.6-12.8 6.4-8.533333 10.666667-17.066667 10.666667-27.733334s-4.266667-19.2-10.666667-27.733333-17.066667-12.8-25.6-12.8h-100.266666v-123.733333h104.533333z m-563.2 2.133334c-4.266667 12.8-12.8 23.466667-21.333333 32-8.533333 8.533333-21.333333 14.933333-34.133334 19.2-12.8 4.266667-27.733333 6.4-42.666666 6.4h-12.8l-12.8-4.266667-14.933334-2.133333c-4.266667 0-8.533333-2.133333-12.8-4.266667-10.666667-4.266667-17.066667-12.8-17.066666-23.466667v-145.066666-6.4c0-2.133333 2.133333-4.266667 2.133333-4.266667 2.133333-2.133333 6.4-4.266667 10.666667-6.4 8.533333-2.133333 19.2-4.266667 27.733333-6.4 10.666667 0 19.2-2.133333 27.733333-2.133333 17.066667 0 29.866667 2.133333 44.8 6.4 12.8 4.266667 23.466667 10.666667 34.133334 19.2 8.533333 8.533333 17.066667 19.2 21.333333 29.866666 4.266667 12.8 8.533333 27.733333 8.533333 44.8 0 19.2-4.266667 34.133333-8.533333 46.933334z m166.4 38.4c-2.133333 4.266667-6.4 6.4-12.8 10.666666-4.266667 2.133333-8.533333 4.266667-14.933333 4.266667-6.4 2.133333-14.933333 2.133333-25.6 2.133333-14.933333 0-27.733333-2.133333-40.533334-6.4-12.8-4.266667-23.466667-10.666667-32-17.066666-8.533333-8.533333-17.066667-19.2-21.333333-32-4.266667-12.8-8.533333-27.733333-8.533333-44.8s2.133333-29.866667 8.533333-42.666667c4.266667-12.8 12.8-23.466667 21.333333-32 8.533333-8.533333 19.2-14.933333 32-19.2 12.8-4.266667 25.6-6.4 38.4-6.4 19.2 0 34.133333 2.133333 44.8 8.533333 10.666667 6.4 14.933333 14.933333 14.933334 23.466667 0 6.4-2.133333 10.666667-4.266667 14.933333-2.133333 4.266667-6.4 6.4-8.533333 8.533334-6.4-4.266667-10.666667-6.4-17.066667-8.533334-6.4-2.133333-14.933333-4.266667-21.333333-4.266666-14.933333 0-27.733333 4.266667-36.266667 14.933333-8.533333 10.666667-12.8 23.466667-12.8 40.533333 0 19.2 4.266667 32 12.8 42.666667 8.533333 8.533333 21.333333 14.933333 38.4 14.933333 8.533333 0 14.933333-2.133333 21.333333-4.266666 6.4-2.133333 10.666667-4.266667 17.066667-8.533334 4.266667 2.133333 6.4 6.4 8.533333 10.666667 2.133333 4.266667 2.133333 8.533333 2.133334 14.933333-2.133333 6.4-2.133333 12.8-4.266667 14.933334z m181.333333-55.466667c0 10.666667-2.133333 21.333333-6.4 29.866667-4.266667 8.533333-8.533333 17.066667-17.066666 23.466666-8.533333 6.4-17.066667 12.8-25.6 14.933334-10.666667 4.266667-23.466667 6.4-34.133334 4.266666-12.8 0-23.466667-2.133333-34.133333-4.266666s-19.2-8.533333-25.6-14.933334c-6.4-6.4-12.8-14.933333-17.066667-23.466666-4.266667-10.666667-6.4-19.2-6.4-29.866667v-119.466667l10.666667-2.133333c4.266667 0 8.533333-2.133333 14.933333-2.133333 10.666667 0 17.066667 2.133333 21.333334 4.266666 4.266667 4.266667 6.4 10.666667 6.4 21.333334v96c0 10.666667 2.133333 17.066667 8.533333 23.466666 6.4 6.4 12.8 8.533333 21.333333 8.533334 4.266667 0 8.533333 0 10.666667-2.133334 4.266667-2.133333 6.4-4.266667 10.666667-6.4 6.4-6.4 8.533333-12.8 8.533333-23.466666v-119.466667l10.666667-2.133333c4.266667 0 8.533333-2.133333 14.933333-2.133334 10.666667 0 17.066667 2.133333 23.466667 4.266667 4.266667 4.266667 6.4 10.666667 6.4 21.333333v100.266667z"
                    p-id="3118"
                    fill="url(#gradientxa)"
                  ></path>
                </svg>

                <div class="list-box-content">
                  <span
                    style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >30%</span
                  >
                  <span style="font-size: 0.85rem">系统负载</span>
                </div>
              </div>
              <el-divider direction="vertical"></el-divider>
              <div class="list-box">
                <svg
                  t="1742965994399"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3296"
                  width="40"
                  height="40"
                >
                  <defs>
                    <linearGradient
                      id="gradientxc"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    >
                      <stop
                        offset="0%"
                        style="stop-color: #7aaafd; stop-opacity: 1"
                      />
                      <stop
                        offset="100%"
                        style="stop-color: #3981fe; stop-opacity: 1"
                      />
                    </linearGradient>
                  </defs>
                  <path
                    d="M755.413333 579.989333A391.232 391.232 0 0 0 513.92 981.333333H42.666667c0-259.2 210.133333-469.333333 469.333333-469.333333 89.130667 0 172.437333 24.832 243.413333 67.989333zM512 512c-129.6 0-234.666667-105.066667-234.666667-234.666667S382.4 42.666667 512 42.666667s234.666667 105.066667 234.666667 234.666666-105.066667 234.666667-234.666667 234.666667z m195.541333 156.458667H981.333333V746.666667H707.541333v-78.208z m-78.208 117.333333H981.333333V864H629.333333v-78.208z m-39.125333 117.333333H981.333333V981.333333H590.208v-78.208z"
                    fill="url(#gradientxc)"
                    p-id="3297"
                  ></path>
                </svg>

                <div class="list-box-content">
                  <span
                    style="font-size: 1.4rem; color: #333; font-weight: bold"
                    >124</span
                  >

                  <span style="font-size: 0.85rem">在线用户</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="box-content-tab">
          <!-- <div class="content-tab-left " :class="{ fixed: isFixed }"> -->
          <div class="content-tab-left">
            <div style="padding: 20px 10px">
              <svg
                t="1742972308193"
                class="icon"
                style="margin-left: -36px"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5148"
                width="20"
                height="20"
              >
                <path
                  d="M877.717333 665.6V36.565333C877.717333 14.634667 863.082667 0 841.152 0c-21.952 0-36.586667 14.634667-36.586667 36.565333V665.6c-43.882667 14.634667-73.130667 58.517333-73.130666 102.4s29.248 87.765333 73.130666 102.4v117.034667c0 21.930667 14.634667 36.565333 36.586667 36.565333 21.930667 0 36.565333-14.634667 36.565333-36.565333V870.4c43.882667-14.634667 73.130667-58.517333 73.130667-102.4 0-51.2-29.248-87.765333-73.130667-102.4z m-36.565333 138.965333c-21.952 0-36.586667-14.613333-36.586667-36.565333s14.634667-36.565333 36.586667-36.565333c21.930667 0 36.565333 14.613333 36.565333 36.565333s-14.634667 36.565333-36.565333 36.565333zM146.282667 665.6V36.565333C146.282667 14.634667 131.648 0 109.717333 0 87.765333 0 73.152 14.634667 73.152 36.565333V665.6C29.226667 680.234667 0 716.8 0 768c0 43.882667 29.248 87.765333 73.152 102.4v117.034667c0 21.930667 14.613333 36.565333 36.565333 36.565333 21.930667 0 36.565333-14.634667 36.565334-36.565333V870.4c43.882667-14.634667 73.152-58.517333 73.152-102.4 0-51.2-29.269333-87.765333-73.152-102.4z m-36.565334 138.965333c-21.952 0-36.565333-14.613333-36.565333-36.565333s14.613333-36.565333 36.565333-36.565333c21.930667 0 36.565333 14.613333 36.565334 36.565333s-14.634667 36.565333-36.565334 36.565333zM512 153.6V36.565333C512 14.634667 497.365333 0 475.434667 0c-21.952 0-36.586667 14.634667-36.586667 36.565333V153.6c-43.882667 14.634667-73.130667 58.517333-73.130667 102.4s29.248 87.765333 73.130667 102.4v629.034667c0 21.930667 14.634667 36.565333 36.586667 36.565333C497.365333 1024 512 1009.365333 512 987.434667V358.4c43.882667-14.634667 73.152-58.517333 73.152-102.4S555.882667 168.234667 512 153.6z m-36.565333 138.965333c-21.952 0-36.586667-14.613333-36.586667-36.565333s14.634667-36.565333 36.586667-36.565333C497.365333 219.434667 512 234.026667 512 256s-14.634667 36.565333-36.565333 36.565333z"
                  fill="#666666"
                  p-id="5149"
                ></path>
              </svg>
              <span style="font-size: 1.1rem">模型筛选</span>
              <span
                style="
                  float: right;
                  font-size: 0.85rem;
                  margin-top: 4px;
                  color: #666;
                "
                >共有
                <span style="color: #4384f4; font-weight: 500">{{ all }}</span>
                个模型</span
              >
            </div>
            <el-divider></el-divider>
            <div class="list-pad">
              <p
                style="
                  text-align: left;
                  color: #666;
                  font-size: 0.85rem;
                  margin-bottom: 8px;
                "
              >
                类型
              </p>
              <ul class="list-pad-ul">
                <li
                  v-for="(item, index) in typeAry"
                  :key="index"
                  @click="clickType(index, item)"
                  :class="typeIndex == index ? 'active' : ''"
                >
                  {{ item }}
                </li>
              </ul>
              <p
                style="
                  text-align: left;
                  color: #666;
                  font-size: 0.85rem;
                  margin-bottom: 8px;
                "
              >
                系列 / 厂商
              </p>
              <ul class="list-pad-ul">
                <li
                  v-for="(item, index) in manufacturerAry"
                  :key="index"
                  @click="manufacturerType(index, item)"
                  :class="manufacturerIndex == index ? 'active' : ''"
                >
                  {{ item }}
                </li>
              </ul>
              <p
                style="
                  text-align: left;
                  color: #666;
                  font-size: 0.85rem;
                  margin-bottom: 8px;
                "
              >
                版本
              </p>
              <ul class="list-pad-ul">
                <li
                  v-for="(item, index) in versionAry"
                  :key="index"
                  @click="versionType(index, item)"
                  :class="versionIndex == index ? 'active' : ''"
                >
                  {{ item }}
                </li>
              </ul>
              <p
                style="
                  text-align: left;
                  color: #666;
                  font-size: 0.85rem;
                  margin-bottom: 8px;
                "
              >
                量化精度
              </p>
              <ul class="list-pad-ul">
                <li
                  v-for="(item, index) in quantizationAry"
                  :key="index"
                  @click="quantizationType(index, item)"
                  :class="quantizationIndex == index ? 'active' : ''"
                >
                  {{ item }}
                </li>
              </ul>
              <p
                style="
                  text-align: left;
                  color: #666;
                  font-size: 0.85rem;
                  margin-bottom: 8px;
                "
              >
                规格
              </p>
              <ul class="list-pad-ul">
                <li
                  v-for="(item, index) in specificationsAry"
                  :key="index"
                  @click="specificationsType(index, item)"
                  :class="specificationsIndex == index ? 'active' : ''"
                >
                  {{ item }}
                </li>
              </ul>
              <p
                style="
                  text-align: left;
                  color: #666;
                  font-size: 0.85rem;
                  margin-bottom: 8px;
                "
              >
                上下文
              </p>
              <ul class="list-pad-ul">
                <li
                  v-for="(item, index) in contextAry"
                  :key="index"
                  @click="contextType(index, item)"
                  :class="contextIndex == index ? 'active' : ''"
                >
                  {{ item }}
                </li>
              </ul>
              <p
                style="
                  text-align: left;
                  color: #666;
                  font-size: 0.85rem;
                  margin-bottom: 8px;
                "
              >
                发布时间
              </p>
              <ul class="list-pad-ul">
                <li
                  v-for="(item, index) in timeAry"
                  :key="index"
                  @click="timeType(index, item)"
                  :class="timeIndex == index ? 'active' : ''"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
          <div class="content-tab-right">
            <div style="text-align: left">
              <el-input
                v-model="seach"
                placeholder="请输入您要查询的模型"
                style="width: 700px; border-radius: 40px"
                @blur="initSeach"
                @keyup.enter.native="initSeach"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i
              ></el-input>
            </div>
            <div class="card-box" v-if="cardAry.length > 0">
              <div
                class="box-card"
                v-for="(item, index) in cardAry"
                :key="index"
                style="position: relative"
              >
                <div
                  style="
                    position: absolute;
                    right: -1px;
                    background: rgb(235, 66, 52);
                    color: rgb(255, 255, 255);
                    top: -1px;
                    padding: 2px 8px;
                    min-width: 20px;
                    border-radius: 0px 5px;
                    font-size: 12px;
                  "
                  v-if="item.tags != ''"
                >
                  {{ item.tags }}
                </div>
                <div class="card-item">
                  <div style="margin-right: 10px">
                    <img :src="item.icon" width="40px" />
                  </div>
                  <div style='margin-top: 6px;'>
                    <p class="item-title">{{ item.title }}</p>
                    <p>
                      <el-tag size="mini">{{ item.type }}</el-tag>
                      <el-tag size="mini" type="info">{{
                        item.model_version
                      }}</el-tag>
                      <el-tag size="mini" type="info">{{
                        item.precision
                      }}</el-tag>
                      <el-tag size="mini" type="info"
                        >{{ item.context }} k</el-tag
                      >
                      <el-tag size="mini" type="info">{{ item.specs }}B</el-tag>
                    </p>
                  </div>
                </div>
                <p class="item-detail">
                  {{ item.intro }}
                </p>
           <!-- <div class="bottom-detail"> -->
                
                  <p class="item-dis">
                    <span style='margin-right:10px;margin-left:-5px;'>【 价格 】</span>
                    <span>输入：<span style='color:#000;'>{{ item.price_input }}</span></span
                    ><span>   <el-divider direction="vertical"></el-divider>输出：<span style='color:#000;'>{{ item.price_output }}</span></span>
                  </p>
                <!-- </div> -->
                  <!-- <p class="item-dis">
                    {{ item.provider }} . 发布于
                    {{ formatDateTime(item.pubdate) }}
                  </p> -->
               
            
                 

                <el-divider></el-divider>
                <div class="item-btn">
                  <div
                    class="btn-color"
                    @click="tyurl(index, item.url_test, item)"
                  >
                    <svg
                      t="1743036976765"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="5367"
                      width="16"
                      height="16"
                    >
                      <path
                        d="M512 1002.666667a490.666667 490.666667 0 1 1 0-981.333334 490.666667 490.666667 0 0 1 0 981.333334z m0-905.856a415.168 415.168 0 1 0 0 830.357333 415.168 415.168 0 0 0 0-830.357333z m-61.653333 598.186666a34.346667 34.346667 0 0 1-19.050667 5.717334 31.274667 31.274667 0 0 1-32.533333-30.186667V353.472c0.042667-6.4 2.218667-12.586667 6.186666-17.578667a34.346667 34.346667 0 0 1 45.290667-6.570666l237.034667 158.506666c2.88 1.792 5.44 4.032 7.552 6.656a28.373333 28.373333 0 0 1-7.552 41.749334L450.346667 694.976z"
                        fill="#2c3e50"
                        p-id="5368"
                      ></path>
                    </svg>
                    <span>在线体验</span>
                  </div>
                  <el-divider direction="vertical"></el-divider>
                  <div @click="apiurl(index, item.url_api, item)">
                    <img
                      src="../image/api.png"
                      width="16px;"
                      style="margin-right: 6px"
                    /><span>API文档</span>
                  </div>
                </div>
              </div>
            </div>
            <el-empty description="暂无数据" v-else></el-empty>
            <el-pagination
              :hide-on-single-page="true"
              style="text-align: right; margin-top: 10px"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 15, 20, 25, 30]"
              :page-size="limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
        <el-backtop target=".home .gub"></el-backtop>
      </div>
    </div>
    <el-backtop target=".home" :bottom="100" :right="40" class="custom-backtop">
      <i class="el-icon-caret-top"></i>
    </el-backtop>
  </div>
</template>

<script>
// @ is an alias to /src
import headerTop from "@/components/headerTop.vue";

export default {
  name: "Home",
  components: {
    headerTop,
  },
  data() {
    return {
      all: 0,
      screenWidth: 0,
      seach: "",
      isFixed: false,
      tabTop: 300, // 固定位置阈值
      total: 0,
      opacity: false,
      limit: 10,
      currentPage: 1,
      typeAry: [],
      typeIndex: null,
      type: "",
      manufacturerAry: [
        " manufacturer",
        "Qwen",
        "QwQ",
        "混元",
        "Llama",
        "Gemma",
      ],
      manufacturerIndex: null,
      manufacturer: "",
      versionBox: [],
      versionAry: [],
      versionIndex: null,
      version: "",
      quantizationAry: ["INT4", "INT8", "FP8", "FP16", "< 4BITS"],
      quantizationIndex: null,
      quantization: "",
      specificationsAry: [],
      specificationsIndex: null,
      specifications: "",
      timeAry: ["1周内", "1个月内", "3个月内", "6个月内", "1年内", "1年以上"],
      timeIndex: null,
      time: "",
      contextAry: ["≥ 8K", "≥ 16K", "≥ 32K", "≥ 128K"],
      contextIndex: null,
      context: "",
      cardAry: [],
    };
  },
  mounted() {
    // 获取滚动容器（height:calc(100vh - 60px) 的 div）
    const scrollContainer = this.$refs.scrollContainer;

    scrollContainer.addEventListener("scroll", this.handleScroll);
    this.handleResize();
    // window.addEventListener("resize", this.handleResize);
    this.searchCondInit();
  },
  beforeDestroy() {
    const scrollContainer = this.$refs.scrollContainer;
    scrollContainer.removeEventListener("scroll", this.handleScroll);
    // window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    initSeach() {
      this.currentPage = 1;
      this.init();
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
      if (this.screenWidth < 1625) {
        this.limit = 10;
      } else if (this.screenWidth > 1625 && this.screenWidth < 1800) {
        this.limit = 15;
      } else if (this.screenWidth > 1800) {
        this.limit = 25;
      }
      console.log("this.limit", this.limit);
      this.init("this.limit", this.limit);
    },
    searchCondInit() {
      let data = {
        op: "search_cond",
      };

      let _this = this;
      this.$axios
        .post("/index.do", _this.Qs.stringify(data), {
          headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          },
        })
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            _this.typeAry = response.data.data.type;
            _this.manufacturerAry = response.data.data.provider;
            _this.versionBox = response.data.data.version; //二维数组
            _this.versionAry = []; //response.data.data.version[0];
            _this.specificationsAry = response.data.data.specs;
            _this.timeAry = response.data.data.pubdate;
            _this.contextAry = response.data.data.context;
            _this.quantizationAry = response.data.data.precision;
            //context
            //pubdate
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    init() {
      console.log(90);
      let data = {
        op: "model_search",
        page: this.currentPage,
        limit: this.limit,
        title: this.seach,
        type: this.type,
        context: this.context,
        specs: this.specifications,
        pubdate: this.time,
        precision: this.quantization,
        version: this.version,
        label: "",
        provider: this.manufacturer,
      };

      let _this = this;
      this.$axios
        .post("/index.do", _this.Qs.stringify(data), {
          headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          },
        })
        .then(function (response) {
          console.log(response);
          if (response.data.value == "ok") {
            _this.cardAry = response.data.data;
            _this.total = response.data.count;
            _this.all = response.data.all;
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleScroll(e) {
      // 滚动到底部判断（距离底部50px时触发）
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      this.isFixed = scrollTop >= this.tabTop;
      // if (scrollHeight - scrollTop - clientHeight < 50) {
      //   this.loadMoreCourses()
      // }
      if (scrollTop > 38) {
        this.opacity = true;
      } else {
        this.opacity = false;
      }
    },

    clickType(index, item) {
      if (this.typeIndex == index) {
        this.typeIndex = null;
        this.type = null;
      } else {
        this.typeIndex = index;
        this.type = item;
      }
      this.init();
    },
    manufacturerType(index, item) {
      if (this.manufacturerIndex == index) {
        this.manufacturerIndex = null;
        this.manufacturer = "";
        this.versionAry = [];
      } else {
        this.manufacturerIndex = index;
        this.manufacturer = item;
        this.versionAry = this.versionBox[index];
        //选择版本
      }
      this.init();
    },
    versionType(index, item) {
      if (this.versionIndex == index) {
        this.versionIndex = null;
        this.version = "";
      } else {
        this.versionIndex = index;
        this.version = item;
      }
      this.init();
    },
    quantizationType(index, item) {
      if (this.quantizationIndex == index) {
        this.quantizationIndex = null;
        this.quantization = "";
      } else {
        this.quantizationIndex = index;
        this.quantization = item;
      }
      this.init();
    },
    specificationsType(index, item) {
      if (this.specificationsIndex === index) {
        this.specificationsIndex = null;
        this.specifications = "";
      } else {
        this.specificationsIndex = index;
        this.specifications = item;
      }
      this.init();
    },
    timeType(index, item) {
      if (this.timeIndex === index) {
        this.timeIndex = null;
        this.time = "";
      } else {
        this.timeIndex = index;
        this.time = item;
      }
      this.init();
    },
    contextType(index, itme) {
      if (this.contextIndex === index) {
        this.contextIndex = null;
        this.context = "";
      } else {
        this.contextIndex = index;
        this.context = itme;
      }
      this.init();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.init();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.init();
    },
    // 时间格式转换方法
    formatDateTime(isoString) {
      const date = new Date(isoString);

      // 处理时区偏移（转换为本地时间）
      const localDate = new Date(
        date.getTime() + date.getTimezoneOffset() * 60000
      );
      /***
   *    ${localDate.getHours().toString().padStart(2, '0')}:
          ${localDate.getMinutes().toString().padStart(2, '0')};
}
   */
      return `${localDate.getFullYear()}年
          ${(localDate.getMonth() + 1).toString().padStart(2, "0")}月
          ${localDate.getDate().toString().padStart(2, "0")}日 `;
    },
    tyurl(index, url, obj) {
      // window.open(url)
      //experience/dialogue
      if (obj.type == "文本对话") {
        this.$router.push({
          path: "experience/dialogue",
          query: { type: "wbzx" },
        });
        window.localStorage.setItem("anjign-wbzx-model", obj.title);
        window.localStorage.setItem("anjign-wbzx", obj.type);
      } else {
        this.$message.info(`类型：【 ${obj.type} 】暂未开放`);
      }
    },
    apiurl(index, url, obj) {
      if (obj.type == "文本对话") {
        this.$router.push({
          path: "api-reference/response",
          query: { type: "wbdh" },
        });
        // window.localStorage.setItem('anjign-wbdh-model',obj.title)
      } else {
        this.$message.info(`类型：【 ${obj.type} 】暂未开放`);
      }
    },
  },
};
</script>
<style scoped>
.home {
  height: 100vh;
  background: #f5f5f5;
  overflow: auto;
}
.home-header {
  background: url("../image/banner.png");
  width: 100vw;
  height: 35vh;
  background-size: cover;
}
.home-box {
  /* padding-top: 8vh; */
}
.home-box-content {
  /* height: 90px; */
  background: #fff;
  width: 100%;
  padding: 24px 0;
  box-sizing: border-box;
}
.box-list {
  width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.list-box {
  display: flex;
}
.list-box-content {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-left: 20px;
  color: #666;
  /* border-right:1px solid #E0E0E0 ; */
}
.list-box svg {
  margin-top: 6px;
}
.header-font {
  width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
  text-align: left;
  padding-top: 11vh;
  height: 24vh;

  color: #333;
}
.box-content-tab {
  position: relative;
  display: flex;
  margin: 0 auto;
  margin-top: 15px;
  min-width: 1300px;
  width: 90%;
}
/* 侧边栏固定样式 */
.content-tab-left.fixed {
  position: fixed;
  top: 100px;
  width: 250px;
  z-index: 100;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1); /* 可选阴影效果 */
}
.content-tab-left {
  width: 250px;

  background: #fff;
}
.list-pad {
  padding: 15px;
}
.list-pad-ul {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  align-items: stretch;
  font-size: 0.85rem;
  color: #333;
  margin-bottom: 15px;
}
.list-pad-ul li {
  padding: 5px 18px;
  background: #f5f5f5;
  border-radius: 4px 4px 4px 4px;
  cursor: pointer;
}
.list-pad-ul li.active {
  background: #4384f4;
  color: #fff;
}
/* 右侧内容适配 */
.content-tab-right {
  margin-left: 10px; /* 250px侧边栏宽度 + 20px间隙 */
  flex: 1;
  margin-right: 10px;
}
.card-box {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  align-items: stretch;
  margin-top: 10px;
}
.home_i p {
  text-align: left;
}
.box-card {
  background: #fff;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #fff;
}
.box-card:hover {
  border: 1px solid #4384f4;
}

.card-item {
  display: flex;
  margin-bottom: 10px;
}
.item-title {
      color: #333333;
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 7px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    width: 93%;
    float: left;
}
.item-detail {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  color: #666666;
  font-size: 0.85rem;
  height: 40px;
}
.item-dis {
  margin: 15px 0;
  color: #999;
  font-size: 0.7rem;
}
.item-btn {
  display: flex;
  justify-content: space-around;
}
.item-btn div {
  font-size: 0.85rem;
  color: 333;
  cursor: pointer;
}
.item-btn div.btn-color {
  color: #2c3e50;
}
/***#4384f4; */
.home_i img {
  vertical-align: sub;
}
@media (max-width: 1625px) {
  .card-box {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1800px) {
  .card-box {
    grid-template-columns: repeat(4, 1fr);
  }
}
/deep/.el-divider--horizontal {
  margin: 0;
}
</style>
<style >
.home-box-content .el-divider--vertical {
  height: 3rem;
  position: static;
}

.home_i .el-input__inner {
  border-radius: 30px;
}
.home_i .el-tag--mini {
  margin-right: 5px;
  color: #4384f4;
  background: #e6f0ff;
  border-color: #e6f0ff;
}
.home_i .el-tag.el-tag--info {
  border-color: #f4f4f4;
}
.box-card .el-divider--horizontal {
  margin-bottom: 10px;
  margin-top: 15px;
}
.box-card .el-divider--vertical {
  height: 1.5em;
}
.content-tab-left .el-divider--horizontal {
  margin: 0;
}
/* 样式调整 */
.custom-backtop {
  background: #4384f4;
  color: white;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(67, 132, 244, 0.3);
  transition: all 0.3s;
}

.custom-backtop:hover {
  transform: scale(1.1);
  background: #5a9cf8;
}
.header-font-p {
  font-size: 2rem;
  font-weight: bold;
}
.header-font-t {
  font-size: 1.4rem;
  margin: 18px 0;
}
.header-font-s {
  font-size: 1.4rem;
}
.bottom-detail {
  display: flex;
  justify-content: space-between;
}
.bottom-detail p {
    /* margin-bottom: -10px !important; */
}
@media (max-width: 1400px) {
  .header-font-p {
    font-size: 1.5rem;
    font-weight: 500;
  }
  .header-font-t {
    font-size: 1rem;
    margin: 18px 0;
  }
  .header-font-s {
    font-size: 1rem;
  }
}
</style>

